
const Defaults = {
    baseURL: "https://api.json2video.com/v2",
};

export default Defaults;